import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, postData, putData } from "src/utils/axios/serverHelper";

import { SYS2010_R01Dto } from "./Dto_SYS2010_R01";
import { SYS2010_R01Filter } from "./Store_SYS2010_R01";

const baseUrl = `${config.apiUrl}/SYS2010_R01`;

// 메뉴 리스트 조회 (검색 조건 포함)
export const getSYS2010_R01List = async (option: string, params: Partial<SYS2010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;
	return await getData<ResponseDto<SYS2010_R01Dto[]>>(url, { params: 
		{
			...params,
			listLength
		}
	 });
}

export const getSYS2010_R01AllCount = async (params: Partial<SYS2010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}

// 신규 등록
export const postSYS2010_R01 = async (data: SYS2010_R01Dto[]) => {
  const url = `${baseUrl}`;  //  경로 수정
  return await postData<SYS2010_R01Dto[], ResponseDto<SYS2010_R01Dto[]>>(url, data);
}

// 수정 (다건 수정이므로 배열 받음)
export const patchSYS2010_R01 = async (data: SYS2010_R01Dto[]) => {
  const url = `${baseUrl}`;  //  경로 수정
  return await putData<SYS2010_R01Dto[], ResponseDto<SYS2010_R01Dto[]>>(url, data);
}

// 삭제
export const deleteSYS2010_R01 = async (menuCd: string) => {
  const url = `${baseUrl}/${menuCd}`;
  return await deleteData<ResponseDto<any>>(url);
}


// 엑셀 다운로드
export const exportSYS2010_R01Excel = async (option: string, params: Partial<SYS2010_R01Filter>, listLength: number = 0) => {
  const url = `${baseUrl}/excel/${option}`;
  return await getData<ResponseDto<string>>(url, { params: {
		...params,
		listLength
	} });
}

